export default __webpack_public_path__ + "static/media/bonus@3x.2a375ecb.png";